// extracted by mini-css-extract-plugin
export default {"container":"participants_container__BOiv9","verticalFiller":"participants_verticalFiller__eR5U9"};